import React, {useCallback, useMemo, useState} from "react";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import {Droppable, DragDropContext} from "react-beautiful-dnd";
import TableRowDnd from "./TableRowDnd";
import ContextMenu from "./ContextMenu";
import TablePaginationActions from "../ListScreenComponent/List/Table/TableFooter/TablePaginationActions";
import useShallowCompareEffect from "../../../../../Hooks/useShallowCompareEffect";
import {useDeepCompareCallback, useDeepCompareEffect} from "use-deep-compare";

const initialContextState = {
    mouseX: null,
    mouseY: null,
    index: null
};
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;

};

function useListData(data, page, pageSize, isPaged, allowedActions) {
    let startData = allowedActions ? [{_props: {sourceIndex: 0}}] : [];
    const [sourceData, setSourceData] = useState(startData);
    const [pagedData, setPagedData] = useState(startData);

    useDeepCompareEffect(() => {
        const start = page * pageSize;

        if(!Array.isArray(sourceData)) {
            console.log('wrong data type at Table Rendering data', typeof sourceData);
            return
        }
        let paged = isPaged ? sourceData?.slice(page * pageSize, page * pageSize + pageSize).map((item, idx) => ({
            ...item,
            _props: {
                ...(item._props || {}),
                sourceIndex: start + idx
            }
        })) : sourceData.map((item, idx) => {
            return {
                ...item,
                _props: {
                    sourceIndex: idx,
                }
            }
        });
        setPagedData(paged?.length ? paged : startData)
    }, [sourceData, page, pageSize]);

    useDeepCompareEffect(() => {
        data && setSourceData(data);
    }, [data]);

    return [pagedData, sourceData];
}


const TableBodyRendering = (props) => {
    const {
        globalValues, screenName, actionsContext,
        path, component, setValue, addGroup, removeGroup,
        allowActions, paged, pageSize: pageSizeParam,
        onClickEvent,
    } = props;
    const currentArray = useMemo(() => {
        if (!path) return false;

        return findByString({...globalValues.param[screenName], ...actionsContext}, path);
    }, [path, JSON.stringify(globalValues.param[screenName])])
    const [arrayToRender, setArrayToRender] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize] = useState(pageSizeParam || 5);
    const [contextMenu, setContextMenu] = useState(initialContextState);

    const [pagedData, sourceData] = useListData(currentArray, page, pageSize, paged, allowActions);

    useShallowCompareEffect(() => {
        if (currentArray && Array.isArray(currentArray)) {
            setArrayToRender(currentArray)
        }
    }, [currentArray]);

    const onDragEnd  = useDeepCompareCallback((result) => {
        const reordered = reorder(arrayToRender, result.source.index, result.destination.index);
        setArrayToRender(reordered)
        setValue(reordered, path)
    },[arrayToRender])

    const openContextMenu = useCallback((e, index) => {
        setContextMenu({mouseX: e.clientX - 2, mouseY: e.clientY - 4, index})
    }, [])

    const closeContextMenu = useCallback(() => {
        setContextMenu(initialContextState)
    }, [])

    const addOneRow = useDeepCompareCallback((index, direction) => {
        addGroup(path, index + direction);
    }, [arrayToRender, path]);

    const removeOneRow = useCallback((index) => {
        if (arrayToRender.length === 1) {
            setValue(undefined, path)
            return
        }
        removeGroup(path + '.' + index)
    }, [path, JSON.stringify(arrayToRender)]);

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={path}>
                {provided => (
                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                    {pagedData?.map(item => (
                        <TableRowDnd
                            key={item._props?.sourceIndex}
                            component={component}
                            rowIndex={1}
                            index={item._props?.sourceIndex}
                            actionsContext={{
                                ...actionsContext,
                                ...{...item, _docIndex: item._props?.sourceIndex},
                                doc: {...item, _docIndex: item._props?.sourceIndex}
                            }}
                            containerArrayPath={path ? `${path}.${item._props?.sourceIndex}` : ''}
                            openContextMenu={openContextMenu}
                            allowActions={allowActions}
                            onClickEvent={onClickEvent}
                            handleMouseMove={props.handleMouseMove}
                        />
                    ))}
                    {provided.placeholder}
                    </tbody>
                )}
            </Droppable>
            {paged && (
                <div style={{
                    width: '100%',
                    paddingLeft: allowActions ? 60 : 0,
                    paddingTop: 10
                }}>
                    <TablePaginationActions
                        count={sourceData?.length}
                        page={page}
                        rowsPerPage={pageSize}
                        totalElements={sourceData?.length}
                        changePage={(e, page) => setPage(page)}
                    />
                </div>
            )}
            <ContextMenu
                contextMenu={contextMenu}
                onClose={closeContextMenu}
                removeItem={removeOneRow}
                addItem={addOneRow}
            />
        </DragDropContext>
    )
}

export default JsonScreenHoc(TableBodyRendering)
